import * as ActionTypes from "constants/ActionTypes";

// `SET_VOLUME_MUTED`
export const setVolumeMuted = (value) => ({
  type: ActionTypes.SET_VOLUME_MUTED,
  value,
});

// `TOGGLE_VOLUME_MUTED`
export const toggleVolumeMuted = () => ({
  type: ActionTypes.TOGGLE_VOLUME_MUTED,
});

export const setVolumeInitiallyMuted = (value) => ({
  type: ActionTypes.SET_INITIALLY_MUTED,
  value,
});

export const unmuteVolumeFromUIActivity = () => ({
  type: ActionTypes.UNMUTE_VOLUME_FROM_UI_ACTIVITY,
});
